export const parseEstablishmentToModel = (qrData) => {
    return {
        name: qrData.name,
        location: qrData.location,
        pictureURL: `${process.env.REACT_APP_CDN_URL}${qrData.pictureURL}`,
        description: qrData.description,
        contractSectionId: qrData.contractSectionId,
        sections: qrData.sections
    };
};